import BipolarAssessmentResult from './BipolarAssessmentResult';

export default BipolarAssessmentResult;
